export const getLocalDayKey = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const clearDailyTaskExecutionData = (taskExecutionData = {}) => {
  const nextTaskExecutionData = { ...taskExecutionData };
  const removeFields = (prefix, fields) => {
    Object.entries(nextTaskExecutionData).forEach(([key, value]) => {
      if (!key.startsWith(prefix) || !value || typeof value !== "object") return;
      const nextValue = { ...value };
      fields.forEach((field) => delete nextValue[field]);
      if (Object.keys(nextValue).length === 0) {
        delete nextTaskExecutionData[key];
      } else {
        nextTaskExecutionData[key] = nextValue;
      }
    });
  };

  // 仅删除当天计数/跳过/退避，保留目标学习与共享题库。
  removeFields("resource_harvest_", ["dailySkip", "dailyPlunder", "noTimerCount"]);
  removeFields("night_attack_nest_", ["noTargetCount"]);
  removeFields("tongtian_", ["lastPurchaseDate", "purchaseCount"]);
  return nextTaskExecutionData;
};
